// Generated by CoffeeScript 1.12.7

/*
TODO: refactor so nothing in inspect/* uses BaseObject
Then, move into StandardLib.
 */

(function() {
  module.exports = [[require("./Inspector"), "shallowInspect inspectLean inspect"], require('./FormattedInspect'), require('./InspectedObjects'), require('./PlainObjects'), require('./InspectedObjectLiteral')];

}).call(this);

//# sourceMappingURL=Inspect.js.map
